import {Inject, Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {Auth} from '@angular/fire/auth';
import {Firestore, DocumentReference} from '@angular/fire/firestore';
import {User} from '../model/user.model';
import {User as FirebaseUser} from 'firebase/auth';
import {AUTH_INTEROP, AuthInterop, FIRESTORE_INTEROP, FirestoreInterop} from '../firebase-interop';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements OnDestroy {
  userData: Observable<FirebaseUser | null>;
  isLoggedIn = false;
  isAdmin = false;
  error: string | undefined;
  user: User | undefined;

  private userSubject = new BehaviorSubject<User | undefined>(undefined);
  user$ = this.userSubject.asObservable();
  private userSubscription?: Subscription;
  private authSubscription: Subscription;

  constructor(
      private auth: Auth,
      private router: Router,
      private firestore: Firestore,
      @Inject(AUTH_INTEROP) private authInterop: AuthInterop,
      @Inject(FIRESTORE_INTEROP) private firestoreInterop: FirestoreInterop
  ) {
    this.userData = this.authInterop.authState(this.auth);
    this.authSubscription = this.userData.subscribe(res => this.handleAuthState(res));
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
    this.authSubscription?.unsubscribe();
    this.userSubject.complete();
  }

  updateUser(fuser: FirebaseUser) {
    this.authInterop.updateCurrentUser(this.auth, fuser).then(res => {
      console.log('You are Successfully updated!', res);
    }).catch(error => {
      console.log('Something is wrong:', error.message);
    });
  }

  SignIn(email: string, password: string) {
    this.authInterop.signInWithEmailAndPassword(this.auth, email, password).then(() => {
      console.log('You are Successfully logged in!');
      this.error = '';
    }).catch(err => {
      console.log('Something is wrong:', err.message);
      this.error = err.message;
    });
  }

  SignOut() {
    this.isLoggedIn = false;
    this.userSubscription?.unsubscribe();
    this.userSubscription = undefined;
    this.userSubject.next(undefined);
    this.authInterop.signOut(this.auth).then(() => {
      this.router.navigate(['login']);
    });
  }

  ForgotPasswod(email: string) {
    this.authInterop.sendPasswordResetEmail(this.auth, email).then(() => {
      this.error = 'You are Successfully sendet a password reset email!';
    }).catch(err => {
      console.log('Something is wrong:', err.message);
      this.error = err.message;
    });
  }

  private handleAuthState(res: FirebaseUser | null) {
    if (res) {
      this.userSubscription?.unsubscribe();
      const userRef = this.firestoreInterop.doc(this.firestore, `users/${res.uid}`) as DocumentReference<User>;
      this.userSubscription = this.firestoreInterop.docData<User>(userRef, {idField: 'id'}).subscribe(user => {
        this.user = user;
        this.isAdmin = !!user && user.role === 'admin';
        this.userSubject.next(user ?? undefined);
      });
      this.isLoggedIn = true;
      return;
    }

    this.isLoggedIn = false;
    this.isAdmin = false;
    this.user = undefined;
    this.userSubject.next(undefined);
    this.userSubscription?.unsubscribe();
    this.userSubscription = undefined;
  }
}
